import { QueryConfig } from "store/utils/query-config";

export const ticketsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-createdAt"],
  },
};
